import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';
import { WebapiService } from 'src/app/shared/services/webapi.service';
import { CustomValidators } from 'src/app/shared/validators/CustomValidators';
import { AppState } from 'src/app/store/app.states';
import { getAdminUserInfo } from 'src/app/store/selector/selector';

declare var bootstrap: any;
declare var $: any;  

@Component({
  selector: 'app-admin-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit,OnChanges {
  @Input() modalid:any;
  @Output() newItemEvent = new EventEmitter<string>();
  submitting=false;
  maxBirthdayDate = new Date();
  countries:any=[];
  subscriptions={};
  @Input() user:any;

  Form: FormGroup = this.fb.group({
    email: ['', Validators.compose([Validators.required, Validators.email])],
    re_email: ['', Validators.compose([Validators.required])],
    password: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
    re_password: ['', Validators.compose([Validators.required,Validators.minLength(8)])],
    first_name: ['', Validators.compose([Validators.required])],
    last_name: ['', Validators.compose([Validators.required])],
    dob: ['', Validators.compose([Validators.required, CustomValidators.noFutureDateValidator])],
    country: ['', Validators.compose([Validators.required])],
    gym_name: ['', Validators.compose([Validators.required])],
    form_type: ['coach', Validators.compose([Validators.required])],
    // number_of_coaches: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])],
    // number_of_athletes: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])],
    number_of_coaches: [''],
    number_of_athletes: [''],
    plan:['']
  },
  { validators: [CustomValidators.MatchValidator('password', 're_password'),CustomValidators.MatchValidator('email', 're_email')] }
  );

  constructor(private fb: FormBuilder,private store: Store<AppState>, private toastrService: ToastrService, public adminApi: AdminapiService, public webApi: WebapiService) {
    this.Form.get('form_type').valueChanges.subscribe(val => {
      if (val=="coach" || val=="gymowner") {
        this.Form.controls['gym_name'].setValidators([Validators.required]);
      } else {
        this.Form.controls['gym_name'].clearValidators();
      }
      this.Form.controls['gym_name'].updateValueAndValidity();
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
    
    this.maxBirthdayDate.setFullYear( this.maxBirthdayDate.getFullYear() - 18 );
  }

  ngOnChanges(changes: SimpleChanges): void {
      this.initForm()
  }

  ngOnInit()  
  {    
    this.getUsersFormData()
  } 

  addNewItem(value: string) {
    this.newItemEvent.emit(value);
  }

  
  initForm(){
    this.Form = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      re_email: ['', !this.user?Validators.compose([Validators.required]):null],
      password: ['', !this.user?Validators.compose([Validators.required, Validators.minLength(8)]):null],
      re_password: ['', !this.user?Validators.compose([Validators.required,Validators.minLength(8)]):null],
      first_name: ['', Validators.compose([Validators.required])],
      last_name: ['', Validators.compose([Validators.required])],
      dob: ['', Validators.compose([Validators.required, CustomValidators.noFutureDateValidator])],
      country: ['', Validators.compose([Validators.required])],
      gym_name: ['', Validators.compose([Validators.required])],
      form_type: ['', Validators.compose([Validators.required])],
      // number_of_coaches: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])],
      // number_of_athletes: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])],
      plan:['']
    });
    // this.Form = this.fb.group({
    //   first_name: ['', Validators.compose([Validators.required])],
    //   last_name: ['', Validators.compose([Validators.required])],
    //   dob: ['', Validators.compose([Validators.required])],
    //   country: ['', Validators.compose([Validators.required])],
    //   gym_name: ['', Validators.compose([Validators.required])],
    //   form_type:['']
    // });
    if(this.user?.first_name){
      this.Form.patchValue({
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        dob: new Date(this.user.dob),
        country: this.user.country,
        gym_name:this.user.gym_name,
        form_type:this.user.role,
        plan:this.user?.plan?.subscription_code,
        email: this.user?.email
      });
      setTimeout( ()=> { 
        const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        $('.selectpicker').selectpicker({ virtualScroll: (isFirefox)? false:600 }).selectpicker('refresh');
      },1000);
    }
  }

  getUsersFormData(){
    this.adminApi.setLoader(true)
    this.adminApi.getUsersFormData().subscribe((data: any) => {
      this.subscriptions=data.subscriptions
      this.countries=data.countries
      setTimeout( ()=> { 
        const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        $('.selectpicker').selectpicker({ virtualScroll: (isFirefox)? false:600 }).selectpicker('refresh');
      }, 600); 
      this.adminApi.setLoader(false)
    },error=>{
      this.adminApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
  }

  roleMatch(role,role2){
    if(role==role2){
      return true;
    }
    return false;
  }

  changeFormType() {
    this.Form.patchValue({
      plan:""
    });
    setTimeout( ()=> { 
      const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
      $('.selectpicker').selectpicker({ virtualScroll: (isFirefox)? false:600 }).selectpicker('refresh');
    },1000);
  }

  onSubmit(form: FormGroup) {
    if (form.valid && !this.submitting) {
      this.submitting = true;
      form.value.dob = this.webApi.formatDate(form.value.dob)
      if(this.user){
        form.value.id=this.user.id
      }
      this.adminApi.addUser(form.value).subscribe((data: any) => {
        if (data.success) {
          this.addNewItem('change')
          form.reset();
					this.toastrService.success(data.message);
          $('#'+this.modalid).modal('hide');
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.submitting = false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.submitting=false;
      });
    } else {
      this.adminApi.validateAllFields(form);
    }
  }

  get f2(): { [key: string]: AbstractControl } {
    return this.Form.controls;
  }


  
}


